import type { ReadingPaneConversationOptions } from "owa-outlook-service-option-store";
import { getOptionsForFeature, OwsOptionsFeatureType } from "owa-outlook-service-option-store";
import type ReactListViewType from "owa-service/lib/contract/ReactListViewType";
import { getUserConfiguration } from "owa-session-store";

// This function is used to get the legacy reading pane conversation option
// OWS' ReadingPaneConversationOptions and GlobalListViewTypeReact
export default function getLegacyRPConversationEnabledOption(): boolean {
    const readingPaneConversationOptions = getOptionsForFeature<ReadingPaneConversationOptions>(OwsOptionsFeatureType.ReadingPaneConversation);
    if (readingPaneConversationOptions) {
        return readingPaneConversationOptions.conversationEnabled;
    }
    else {
        const userOptions = getUserConfiguration().UserOptions;
        return userOptions?.GlobalListViewTypeReact === 0;
    }
}
